document.addEventListener("DOMContentLoaded", function() {
    var targetNode = document.body;

    var config = { childList: true, subtree: true };

    var callback = function(mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                var storeAvailabilityLink = document.querySelector('.iia-drawer-link');
                if (storeAvailabilityLink) {
                    storeAvailabilityLink.textContent = "店舗在庫を見る";
                    
                    observer.disconnect();
                    break;
                }
            }
        }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
});